import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { noteStateType } from "../types";
import {
  createQuickCollection,
  getCollections,
  getCollection,
  deleteCollection,
  updateCollection,
  updateNotePositionsInCollection,
  addTaskToCollection,
  removeTaskFromCollection,
} from "./collection.thunk";

export function addCollectionReducers(
  builder: ActionReducerMapBuilder<noteStateType>,
) {
  builder
    .addCase(createQuickCollection.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(createQuickCollection.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      if (state.collections) {
        state.collections.push(action.payload);
      } else {
        state.collections = [action.payload];
      }
    })
    .addCase(createQuickCollection.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    })
    .addCase(getCollections.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(getCollections.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.collections = action.payload;
    })
    .addCase(getCollections.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    })

    // Get collection by ID
    .addCase(getCollection.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(getCollection.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.collection = action.payload;
    })
    .addCase(getCollection.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    })

    .addCase(deleteCollection.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(deleteCollection.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.collections = state.collections?.filter(
        (collection) => collection.id !== action.payload,
      );
      if (state.project)
        state.project.Collections = state.project?.Collections?.filter(
          (col) => col.id !== action.payload,
        );
    })
    .addCase(deleteCollection.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    })
    .addCase(updateCollection.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(updateCollection.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.collections = state.collections?.map((collection) =>
        collection.id !== action.payload.id
          ? collection
          : { ...collection, ...action.payload },
      );

      if (state.collection) {
        state.collection = { ...state.collection, ...action.payload };
      }
    })
    .addCase(updateCollection.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    })

    .addCase(updateNotePositionsInCollection.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(updateNotePositionsInCollection.fulfilled, (state, action) => {
      const { collectionId, updatedNotes } = action.payload;
      state.isLoading = false;
      state.isSuccess = true;

      if (state.collection?.id === collectionId) {
        state.collection = {
          ...state.collection,
          notes: state.collection.notes?.map((note) => {
            const updatedNote = updatedNotes.find(
              (updated: { taskId: string }) => updated.taskId === note.noteId,
            );
            return updatedNote
              ? { ...note, positionInList: updatedNote.position }
              : note;
          }),
        };
      }
    })
    .addCase(updateNotePositionsInCollection.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    })

    .addCase(addTaskToCollection.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(addTaskToCollection.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;

      if (state.collection?.id === action.payload.collectionId) {
        state.collection = {
          ...state.collection,
          notes: [...(state.collection.notes || []), action.payload],
        };
      }

      state.collections = state.collections?.map((collection) =>
        collection.id !== action.payload.collectionId
          ? collection
          : {
              ...collection,
              notes: [...(collection.notes || []), action.payload],
            },
      );
    })
    .addCase(addTaskToCollection.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    })
    .addCase(removeTaskFromCollection.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    })
    .addCase(removeTaskFromCollection.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;

      if (state.collection?.id === action.payload.collectionId) {
        state.collection = {
          ...state.collection,
          notes: state.collection.notes?.filter(
            (note) => note.noteId !== action.payload.noteId,
          ),
        };
      }

      state.collections = state.collections?.map((collection) =>
        collection.id !== action.payload.collectionId
          ? collection
          : {
              ...collection,
              notes: collection?.notes?.filter(
                (note) => note.noteId !== action.payload.noteId,
              ),
            },
      );
    })
    .addCase(removeTaskFromCollection.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload as string;
    });

  // ...more cases
}
